import React from "react"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"

import PublicLayout from "components/Layout/PublicLayout"
import { publicRoutes, privateRoutes } from "router/routes"
import NotFoundIllustration from "components/Elements/Illustrations/NotFound"
import { useOperator, usePageReducer, useUser } from "hooks"
import { Spinner } from "components/Elements"
import { MOUSTACHE_NAME } from "operators/moustache/config"

export const NotFoundPage: React.FC = () => {
	const navigate = useNavigate()
	const { t } = useTranslation()
	const { user } = useUser()
	const { currentOperator } = useOperator()
	const { dispatchPageIsComplete, isComplete, isLoading } = usePageReducer()

	const redirect = () => {
		navigate(Boolean(user) ? privateRoutes.dashboard.path : publicRoutes.signin.path)
	}

	const isMoustacheOperator = currentOperator?.name === MOUSTACHE_NAME

	const isLinkDisplayed = !isMoustacheOperator

	React.useEffect(() => {
		// Create a fake loader to not to display the 404 content when there is a redirect in progress
		// Example when there is a redirection in dev mode with the operator like /obike_owner/decathlon/s-inscrire
		setTimeout(() => {
			dispatchPageIsComplete()
		}, 1000)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<>
			<PublicLayout>
				{isComplete && (
					<div className="max-w-screen-3xl mx-auto flex flex-col flex-1 justify-center">
						<div className="flex justify-center flex-col items-center">
							<NotFoundIllustration color={"var(--primaryColor"} />
							<h1 className="c-h1 my-14">{t("notFound.title")}</h1>

							{isLinkDisplayed && (
								<button onClick={redirect} className="c-btn c-btn--primary px-4">
									{t("notFound.goback")}
								</button>
							)}
						</div>
					</div>
				)}

				{isLoading && (
					<div className="flex flex-column justify-center items-center mb-8 flex-1">
						<Spinner color={"var(--primaryColor)"} size="200px" />
					</div>
				)}
			</PublicLayout>
		</>
	)
}
